'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbPhonenumber.$inject = ['ValidationService', 'FormattingService'];


var _module = _angular2.default.module('cb.Phonenumber', []);

_module.directive('cbPhonenumber', cbPhonenumber);

exports.default = _module;

/**
 * cb-phonenumber
 *
 * Validate phone number.
 * input element can contain validate-parel or validate-mobile
 * regular validation is with country code (ie +31)
 * parel-validation is Dutch number, starting with 0 and max 10 numbers
 * mobile-validation is Dutch mobile, starting with 06 and max 10 numbers
 */

function cbPhonenumber(ValidationService, FormattingService) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attr, ngModel) {

            var validator = void 0;
            var mobile = false;
            var parel = false;

            validator = function validator(modelValue, viewValue) {
                var value = modelValue || viewValue;
                if (ngModel.$isEmpty(value)) {
                    return true;
                }
                return ValidationService.validatePhonenumber(value);
            };

            if (attr.validateMobile === 'true') {
                mobile = true;
                validator = function validator(modelValue, viewValue) {
                    var value = modelValue || viewValue;
                    if (ngModel.$isEmpty(value)) {
                        return true;
                    }
                    return ValidationService.validateMobilePhonenumber(value);
                };
            }

            if (!mobile && attr.validateParel === 'true') {
                parel = true;
                validator = function validator(modelValue, viewValue) {
                    var value = modelValue || viewValue;
                    if (ngModel.$isEmpty(value)) {
                        return true;
                    }
                    return ValidationService.validateParelPhonenumber(value);
                };
            }

            function parser(value) {
                if (ngModel.$isEmpty(value)) {
                    return null;
                }
                ngModel.$setViewValue(FormattingService.formatPhonenumber(value));
                ngModel.$commitViewValue();
                ngModel.$render();
                return FormattingService.formatPhonenumber(value);
            }

            ngModel.$parsers.push(parser);

            if (parel) {
                ngModel.$validators['phonenumber-parel'] = validator;
            } else if (mobile) {
                ngModel.$validators['phonenumber-mobile'] = validator;
            } else {
                ngModel.$validators['phonenumber'] = validator;
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/forms/phonenumber/cb-phonenumber.directive.js
// module id = 795
// module chunks = 0